import type { Dependencies } from "@redux/store";
import { createAction, createAsyncThunk } from "@reduxjs/toolkit";

export const createCustomerInvoice = createAsyncThunk<void, string, { extra: Partial<Dependencies> }>(
  "trainingInvoices/createCustomerInvoice",
  async (trainingInvoiceId: string, { extra: { adminRepository } }) => {
    return adminRepository!.createCustomerInvoice(trainingInvoiceId);
  },
);

export const resetCreateCustomerInvoice = createAction("trainingInvoices/resetCreateCustomerInvoice");
